import React from 'react';
import { Group, Rect, Text } from 'react-konva';

// areaSqm: مساحتِ فعلی (محور تا محورِ دیوارها)؛ locked: مساحت را کاربر خودش داده (ثابت)
function Otagh({ rowSpans, cellSize, centroid, name, areaSqm, locked, selected, onPointerDown }) {
  const fill = selected ? 'rgba(10, 102, 194, 0.16)' : 'rgba(0, 0, 0, 0.045)';
  const areaText = `${Number(areaSqm || 0).toLocaleString('fa-IR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} متر مربع`;

  return (
    <Group onPointerDown={onPointerDown}>
      {rowSpans.map((span, i) => (
        <Rect
          key={i}
          x={span.x1}
          y={span.y}
          width={span.x2 - span.x1}
          height={span.h || cellSize}
          fill={fill}
        />
      ))}
      <Text
        x={centroid.x - 70}
        y={centroid.y - 14}
        width={140}
        align="center"
        text={name || 'بدون‌نام'}
        fontFamily="Vazirmatn, sans-serif"
        fontStyle="700"
        fontSize={13}
        fill={selected ? '#0a66c2' : '#000000'}
      />
      <Text
        x={centroid.x - 70}
        y={centroid.y + 4}
        width={140}
        align="center"
        text={locked ? `🔒 ${areaText}` : areaText}
        fontFamily="Vazirmatn, sans-serif"
        fontSize={11}
        fontStyle={locked ? '700' : 'normal'}
        fill={locked ? '#1f6f43' : '#8e8e8e'}
      />
    </Group>
  );
}

export default Otagh;
